import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { CustomerType, Product, customerTypeSchema, productSchema } from "./form/useAcquisitionFormSchema"
import { useCallback } from "react"

type SearchParams = "customerType" | "product"

export function useAcquisitionFormSearchParams() {
  const [searchParams] = useSearchParams()
  const customerTypeParam = searchParams.get("customerType")
  const productParam = searchParams.get("product")
  const customerTypeParamResult = customerTypeSchema.safeParse(customerTypeParam)
  const productParamResult = productSchema.safeParse(productParam)

  const navigate = useNavigate()
  const location = useLocation()

  const setSearchParam = useCallback(
    <K extends SearchParams>(
      key: K,
      value: K extends "customerType" ? CustomerType : K extends "product" ? Product : never
    ) => {
      searchParams.set(key, value as unknown as string)
      navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true })
    },
    [location.pathname, navigate, searchParams]
  )

  return {
    customerType: customerTypeParamResult.success ? customerTypeParamResult.data : undefined,
    product: productParamResult.success ? productParamResult.data : undefined,
    setSearchParam,
  }
}
